import script from "./lottoryDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./lottoryDetails.vue?vue&type=script&setup=true&lang=js"

import "./lottoryDetails.vue?vue&type=style&index=0&id=4bb5651e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bb5651e"]])

export default __exports__